import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { toPointer } from '../../core/issues.js';

export const characterDialogueNames: Rule<Gameshow> = {
  code: 'gameshow.character-dialogue.unknown-name',
  check(input): ValidationIssue[] {
    const issues: ValidationIssue[] = [];
    const names = new Set(input.characters.map(c => c.name));

    input.nodes.forEach((node, nodeIdx) => {
      if (!node.characterDialogue) {
        return;
      }
      node.characterDialogue.forEach((line, lineIdx) => {
        if (names.has(line.name)) {
          return;
        }
        const path: (string | number)[] = ['nodes', nodeIdx, 'characterDialogue', lineIdx, 'name'];
        issues.push({
          code: 'gameshow.character-dialogue.unknown-name',
          severity: 'error',
          message: `Node '${node.id}': characterDialogue[${lineIdx}] name '${line.name}' does not match any character name.`,
          path,
          pointer: toPointer(path),
          locator: { nodeId: node.id },
          currentValue: line.name,
          constraint: { kind: 'reference', allowedValues: Array.from(names) },
        });
      });
    });

    return issues;
  },
};
